/**
Project: Voice Panel (c)
Title: Azure Insight Config 
Description: App Insight Logs
Copyrights: This file is subject to the terms and conditions defined in file 'LICENSE.txt', which is part of this source code package.
*/

import { ApplicationInsights } from "@microsoft/applicationinsights-web";
import { ReactPlugin } from "@microsoft/applicationinsights-react-js";

export const reactPlugin = new ReactPlugin();

const ai = new ApplicationInsights({
  config: {
    instrumentationKey:
      process.env.REACT_APP_AZURE_INSIGHTS_INSTRUMENTATION_KEY,
    maxBatchInterval: 0,
    enableAutoRouteTracking: true,
    autoTrackPageVisitTime: true,
    extensions: [reactPlugin],
  },
});

ai.loadAppInsights();

ai.context.application.ver = process.env.REACT_APP_BUILD_VERSION;
ai.context.application.build = `${process.env.REACT_APP_SIPPIO_TITLE} - ${process.env.REACT_APP_BUILD_VERSION}`;

export const appInsights = ai.appInsights;
export const AppInsightscontext = ai.context;
export const getAppInsights = () => ai;
